import { Stack } from "@mui/material";
import { Dialog, Text } from "@flat-ui";
import { FaroLinearProgress } from "@components/common/faro-linear-progress";
interface ExportAllDataDialogProps {
  /** Whether the dialog is open or not */
  isOpen: boolean;

  /** Current export progress details */
  currentPageNumber: number;

  /** Callback when user cancels the export */
  onCancel: () => void;
}

/**
 * Dialog to show export progress with cancellation support
 */
export function ExportAllDataDialog({
  isOpen,
  currentPageNumber,
  onCancel,
}: ExportAllDataDialogProps): JSX.Element {
  const progressMessage =
    currentPageNumber > 0
      ? `Loading page ${currentPageNumber}...`
      : "Starting export...";

  return (
    <Dialog
      title="Exporting all data"
      open={isOpen}
      showXButton={false}
      cancelText="Cancel"
      onCancel={onCancel}
    >
      <Stack spacing={3}>
        <Text variant="bodyM" sx={{ mb: 1 }}>
          Your file will download automatically once all data is loaded.
          <br />
          {progressMessage}
        </Text>

        <FaroLinearProgress
          variant="indeterminate"
          sx={{ mb: 1, height: 8, borderRadius: 4 }}
        />
      </Stack>
    </Dialog>
  );
}
